import { Injectable, NgModule } from "@angular/core";

// @dynamic
@Injectable()
export class SlickSleepService {
	static async sleep(timeout: number = 0): Promise<void> {
		return new Promise<void>((resolve) => setTimeout(() => resolve(), timeout));
	}
}
